const DOLLAR_FIELDS = new Set(['gmv', 'target_capital', 'target_gmv']);
const COUNT_FIELDS = new Set(['count', 'member_count']);

/**
 * Table display only: whole dollars and counts, exactly two percentage
 * decimals, and at most two decimals for other numbers. Scaled dollars
 * keep two decimals. Missing values stay blank, except the saved row's
 * trade idea and position size, which retain their zero placeholder.
 */
export function formatValue(value, {
    field = '',
    header = '',
    isNewRow = false,
    maximumFractionDigits,
} = {}) {
    const blank = value == null || (typeof value === 'string' && value.trim() === '');
    if ((field === 'trade_idea' || field === 'pos_gmv_dollar') && !isNewRow && blank) {
        return '0';
    }
    if (blank) return null;

    const num = typeof value === 'number' ? value : Number(value);
    if (Number.isNaN(num)) {
        return typeof value === 'number' || String(value).trim().toLowerCase() === 'nan'
            ? null : String(value);
    }
    if (!Number.isFinite(num)) return null;

    const percentage = header.includes('%') || field.endsWith('_pct') || field.startsWith('pct_');
    const dollars = header.includes('$') || field.endsWith('_dollar') || DOLLAR_FIELDS.has(field);
    const scaledDollars = /\$\s*(?:k|mm)\b/i.test(header);
    const digits = percentage ? 2 : maximumFractionDigits ?? (
        COUNT_FIELDS.has(field) || (dollars && !scaledDollars) ? 0 : 2
    );
    const text = num.toLocaleString('en-US', {
        minimumFractionDigits: percentage ? 2 : 0,
        maximumFractionDigits: digits,
    });
    return /^-0(?:\.0+)?$/.test(text) ? text.slice(1) : text;
}

// A rounded display must never become an editor's starting numeric value.
// Keep the familiar grouped input text when it still contains all precision.
export function formatInputValue(value, options) {
    const formatted = formatValue(value, options);
    return formatted != null && Number(formatted.replace(/,/g, '')) === Number(value)
        ? formatted : String(value ?? '');
}
